import React from 'react';
import { URLS } from '@wix/da-url';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import { ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportInappropriate = ({ onChange, onHide, activeTypeMap })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Explicit,
        disabled: !activeTypeMap[ReportSectionTypes.Explicit],
        label: 'This is sexually explicit',
        subLabel: /*#__PURE__*/ React.createElement(React.Fragment, null, "Art that goes against", ' ', /*#__PURE__*/ React.createElement("a", {
            href: URLS.MATURE_POLICY,
            target: "_blank",
            rel: "noreferrer",
            className: "text-link-level-2-primary"
        }, "DeviantArt Policy.")),
        onChange: (e)=>onChange(ReportSectionTypes.Explicit)
    }), !activeTypeMap[ReportSectionTypes.Explicit] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Mature,
        disabled: !activeTypeMap[ReportSectionTypes.Mature],
        label: 'This needs a Mature Tag',
        subLabel: /*#__PURE__*/ React.createElement(React.Fragment, null, "Art that should be tagged as “", /*#__PURE__*/ React.createElement("a", {
            href: `${URLS.HELP}article/what-is-mature-content-453216`,
            target: "_blank",
            rel: "noreferrer",
            className: "text-link-level-2-primary"
        }, "Mature"), "” for including nudity, sexual themes, violence/gore, strong language, or is ideologically sensitive"),
        onChange: (e)=>onChange(ReportSectionTypes.Mature)
    }), !activeTypeMap[ReportSectionTypes.Mature] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.Underage,
        disabled: !activeTypeMap[ReportSectionTypes.Underage],
        label: 'This is underage sexualized content',
        subLabel: 'Underage models or characters shown nude or in a sexual context',
        onChange: (e)=>onChange(ReportSectionTypes.Underage)
    }), !activeTypeMap[ReportSectionTypes.Underage] && /*#__PURE__*/ React.createElement("span", {
        className: s['reviewed']
    }, "This has been reviewed by staff.", ' ', /*#__PURE__*/ React.createElement("a", {
        onClick: onHide,
        className: "text-link-level-2-primary"
    }, "Hide Content?")));
};
ReportInappropriate.displayName = 'ReportInappropriate';
export default ReportInappropriate;

//# sourceMappingURL=ReportInappropriate.js.map